import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { PublicNotificationsComponent } from './pages/public-notifications/public-notifications.component';
import { WasteCalendarComponent } from './pages/waste-calendar/waste-calendar.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: WasteCalendarComponent,
        data: {
          title: 'Afvalkalender | Straatbeeld Online'
        }
      },
      {
        path: 'publieke-notificatie/:url',
        component: PublicNotificationsComponent,
        data: {
          title: 'Publieke notificatie | Straatbeeld Online'
        },
      },
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
